import Icon from "components/Elements/Icon/Icon";
import Tooltip from "components/Elements/Tooltip/Tooltip";

interface IUploaderSideBarOptions {
  sideOptions: string[];
  swapFormFunction: (option: string) => void;
  currentOption: string;
  hideJumbopay: boolean;
}

interface ICurrentOption {
  optionKey: string;
  currentOption: string;
  swapFormFunction: (option: string) => void;
}

const CurrentOption = ({
  optionKey,
  currentOption,
  swapFormFunction,
}: ICurrentOption) => {
  return (
    <button
      className={`home-upload-sidebar-option${
        optionKey === currentOption ? " selected" : ""
      }`}
      onClick={() => swapFormFunction(optionKey)}
      key={optionKey}
    >
      <div className="hover-background" />
      {/* @ts-ignore */}
      <Tooltip tooltipTextKey={`tooltip-${optionKey}-text`}>
        <Icon name={optionKey} blue />
      </Tooltip>
    </button>
  );
};

const UploaderSideBarOptions = ({
  sideOptions,
  swapFormFunction,
  currentOption,
  hideJumbopay,
}: IUploaderSideBarOptions) => {
  return (
    <>
      {sideOptions.map((key) => {
        if (hideJumbopay && key === "pay-light") return null;
        return (
          <CurrentOption
            {...{
              optionKey: key,
              currentOption,
              swapFormFunction,
            }}
            key={key}
          />
        );
      })}
    </>
  );
};

export default UploaderSideBarOptions;
